import type { SupSingleVaultV3 } from "@/types";
import React from "react";
import UiLabelSuperPoolTag from "@/components/Ui/Label/SuperPool/Tag";

interface VaultDetailsSuperPoolProps {
  singleVault: SupSingleVaultV3;
}
export default function VaultDetailsSuperPool({ singleVault }: VaultDetailsSuperPoolProps) {
  return singleVault.super_pools?.length > 0 && <UiLabelSuperPoolTag isSmall showTooltip />;
}
